module.exports = __webpack_public_path__ + "assets/img/pt-107e5934.png";